import type { HomeCardProps } from "./types-home-card";
import { HomeCardView } from "./view-home-card";

export function HomeCard(props: HomeCardProps) {
  return <HomeCardView {...props} />;
}

export type * from "./types-home-card";
